module.exports = __webpack_public_path__ + "public/SiteIcons/addListIcon.svg?0dc4b4a6";